module.exports = __webpack_public_path__ + "img/back.4668d5fc.png";